import { render } from "./PurchaseOrders.vue?vue&type=template&id=e8c0d1f6&scoped=true"
import script from "./PurchaseOrders.vue?vue&type=script&lang=js"
export * from "./PurchaseOrders.vue?vue&type=script&lang=js"

import "./PurchaseOrders.vue?vue&type=style&index=0&id=e8c0d1f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8c0d1f6"]])

export default __exports__